import React from "react";
import PropTypes from "prop-types";

import { Button } from "semantic-ui-react";

import { FeatureFlag } from "components/FeatureFlag";

import { useUpdateCommentAssociation } from "../../hooks";

export default function DeleteCommentAssociationButtonWrapper(props) {
  const { disabled, onLegacyDelete } = props;
  return (
    <React.Fragment>
      <FeatureFlag id="comment-filters" showOnDisabled>
        <Button
          data-test="delete-comment-association"
          disabled={disabled}
          basic
          size="mini"
          icon="delete"
          onClick={() => {
            onLegacyDelete();
          }}
        />
      </FeatureFlag>
      <FeatureFlag id="comment-filters">
        <DeleteCommentAssociationButton {...props} />
      </FeatureFlag>
    </React.Fragment>
  );
}

DeleteCommentAssociationButtonWrapper.propTypes = {
  disabled: PropTypes.bool.isRequired,
  onLegacyDelete: PropTypes.func,
};

DeleteCommentAssociationButtonWrapper.defaultProps = {
  onLegacyDelete: () => {
    return Promise.resolve();
  },
};

function DeleteCommentAssociationButton({ comment, disabled, onDelete }) {
  const { updateAssociation: deleteSavedAssociation, isUpdatingAssociation } =
    useUpdateCommentAssociation(comment.id, () => {
      comment.taskUuid = undefined;
      comment.clientWorkflowUuid = undefined;
      comment.relatedEntityTitle = "";
    });

  return (
    <Button
      data-test="delete-comment-association"
      disabled={disabled || isUpdatingAssociation}
      basic
      size="mini"
      icon="delete"
      onClick={() => {
        onDelete(deleteSavedAssociation);
      }}
    />
  );
}

DeleteCommentAssociationButton.propTypes = {
  ...DeleteCommentAssociationButtonWrapper.propTypes,
  onDelete: PropTypes.func.isRequired,
  comment: PropTypes.object,
};

DeleteCommentAssociationButton.defaultProps = {
  comment: {},
};
